import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Headline from 'components/Headline/Headline';
import Loader from 'components/Loader/Loader';
import ActivateToggle from 'components/ActivateToggle/ActivateToggle';
import { KeyValueDTO } from 'generated/models/KeyValueDTO';
import { KeyValueStoreService } from 'generated/services/KeyValueStoreService';

const ToggleShowVoucher = () => {
  // TODO take from kvstore Redux
  const [showVoucher, setShowVoucher] = useState<boolean | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['translation', 'settings']);

  const getValue = async (): Promise<boolean> => {
    const keyValueDto = await KeyValueStoreService.getKeyValueStoreItem(
      KeyValueDTO.key.CREATOR_SHOW_VOUCHER,
    );

    return keyValueDto.value === 'true';
  };

  const setValue = async (): Promise<void> => {
    setLoading(true);

    const keyValueDto = await KeyValueStoreService.setKeyValueStoreItem({
      key: KeyValueDTO.key.CREATOR_SHOW_VOUCHER,
      value: showVoucher ? 'false' : 'true',
    });

    setLoading(false);

    setShowVoucher(keyValueDto.value === 'true');
  };

  useEffect(() => {
    getValue().then((_showVoucher) => setShowVoucher(_showVoucher));
  }, []);

  return (
    <div>
      <Headline className="settings__headline" headingLevel="h2" size={2}>
        {t('settings:toggle-show-voucher.headline')}
      </Headline>

      <p className="settings__block page__form-desc">
        {t('settings:toggle-show-voucher.description')}
      </p>

      {showVoucher === undefined ? (
        <Loader />
      ) : (
        <div>
          <label id="statistic-voucher-toggle-desc" className="input__label">
            {t('edit')}
          </label>

          <ActivateToggle
            active={showVoucher}
            onToggle={setValue}
            ariaDescribedBy="#statistic-voucher-toggle-desc"
            loading={loading}
          />
        </div>
      )}
    </div>
  );
};

export default ToggleShowVoucher;
